const optInValue = [{ title: 'All' }, { title: 'Opted In' }, { title: 'Not Opted In' }]
export const getOptIns = optInValue
